/* eslint-disable react/prop-types */
import React, { useState, useEffect, useContext } from "react";
//Loading
import CustomerClassViewer from "./CustomerClassViewer";
import CustomerBlockViewer from "./CustomerBlockViewer";
// Common
import FadeIn from "../common/FadeIn";
//Context
import { BusinessContextConsumer } from "../BusinessContext";
//Packages
import axios from "axios";
//Loading
import LoadingSpinner from "../LoadingSpinner";
//Analytics
import TagManager from "react-gtm-module";

const CustomerOverview = () => {
  // Manage State
  const [classes, setClasses] = useState([]);
  const [blocks, setBlocks] = useState([]);

  // Context
  const BusinessContext = useContext(BusinessContextConsumer);
  const businessID = BusinessContext.businessID;

  // Get the overview list of classes.
  useEffect(async () => {
    const getData = await axios.get(`/api/public_view/schedule/${businessID}`, {
      withCredentials: true,
    });
    TagManager.dataLayer({
      dataLayer: {
        event: "viewedSchedule",
      },
    });
    setBlocks(getData.data.blockData);
    return setClasses(getData.data.classData);
  }, []);

  return (
    <div className='CustomerClassViewer'>
      <FadeIn delay={250} duration={450}>
        {classes && <CustomerClassViewer classes={classes} />}
        {blocks && <CustomerBlockViewer blocks={blocks} />}
        {!classes && !blocks && <LoadingSpinner />}
      </FadeIn>
    </div>
  );
};

//export the component
export default CustomerOverview;
